<template>
  <div class="library-list-item"
       @click="readOne(item.libNo)">
    <LoadImage
      v-bind="$attrs"
      cover
      class="rounded"
      :aspect-ratio="ratio"
      :src="$downUrl(item.thnImgFileName)"
    >
      <span class="new"
            v-if="!hideNew && isNew"
      >NEW</span>
    </LoadImage>
    <div class="item-title line-clamp-2">
<!--      <span class="new"-->
<!--            v-if="!hideNew && isNew"-->
<!--      >N</span>-->
<!--      {{ item.inqCnt }} / {{ item.likeCnt }} / {{ item.regDt }} / -->
      {{ item.title }}
    </div>
  </div>
</template>

<script>
import Util from '@/utils/utils'
export default  {
  name: 'LibraryItem',
  props: {
    item: {
      type: Object
    },
    hideNew: {
      type: Boolean
    }
  },
  computed: {
    ratio () {
      if (this.$attrs.aspectRatio) return this.$attrs.aspectRatio
      return '1'
    },
    isNew () {
      if (this.item) {
        let diff = Util.Date.diffNow(new Date(), this.item.regDt, 'd')
        if (diff <= 10) return true
      }
      return false
    }
  },
  created () {
    // console.log(this.item)
  },
  methods: {
    readOne(libNo) {
      this.$router.push(`/fo/library/view?libNo=${libNo}`)
    }
  }
}
</script>
